import rootReducer from './index';
import { configureStore } from '@reduxjs/toolkit'

const store = configureStore({
  reducer: rootReducer
})

export { store };